import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { StaggeredReceive } from "features/stock-ordering/core/stock-ordering.params";
import {
  staggeredDispatchRepository,
  staggeredDispatchResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum staggeredDispatchState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: staggeredDispatchState;
  message: string;
}

const initialState: InitialState = {
  status: staggeredDispatchState.initial,
  message: "",
};

export const staggeredDispatch = createAsyncThunk(
  "staggeredDispatch",
  async (param: StaggeredReceive, { rejectWithValue }) => {
    try {
      const response: staggeredDispatchResponse =
        await staggeredDispatchRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const staggeredDispatchSlice = createSlice({
  name: "staggeredDispatch",
  initialState,
  reducers: {
    resetstaggeredDispatch: (state) => {
      state.status = staggeredDispatchState.initial;
      state.message = "Reset request";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(staggeredDispatch.pending, (state) => {
        state.status = staggeredDispatchState.inProgress;
      })
      .addCase(staggeredDispatch.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = staggeredDispatchState.success;
          state.message = message;
        }
      })
      .addCase(staggeredDispatch.rejected, (state, action) => {
        state.status = staggeredDispatchState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectstaggeredDispatch = (state: RootState) =>
  state.staggeredDispatch;

export default staggeredDispatchSlice.reducer;
